import * as Tabs from '@radix-ui/react-tabs';
import { cn } from '../../lib/cn';

function SegmentedTabs({
  value,
  onValueChange,
  items,
  className,
  listClassName,
  ariaLabel = 'Segmented control',
}) {
  return (
    <Tabs.Root value={value} onValueChange={onValueChange} className={className}>
      <Tabs.List
        className={cn(
          'inline-flex items-center gap-1 rounded-xl border border-app-border/80 bg-app-surface p-1 shadow-subtle',
          listClassName
        )}
        aria-label={ariaLabel}
      >
        {items.map((item) => (
          <Tabs.Trigger
            key={item.value}
            value={item.value}
            className="rounded-lg px-3 py-2 text-sm font-medium text-app-muted outline-none transition data-[state=active]:bg-app-accent data-[state=active]:text-white data-[state=active]:shadow-subtle disabled:cursor-not-allowed disabled:opacity-50"
            disabled={item.disabled}
          >
            {item.label}
          </Tabs.Trigger>
        ))}
      </Tabs.List>
    </Tabs.Root>
  );
}

export default SegmentedTabs;
